import script from "./orderList.vue?vue&type=script&setup=true&lang=js"
export * from "./orderList.vue?vue&type=script&setup=true&lang=js"

import "./orderList.vue?vue&type=style&index=0&id=45917194&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45917194"]])

export default __exports__